import { reduce } from "et3-type-guards";
import React from "react";
import Stack from "@mui/material/Stack";
import { useLocation } from "react-router-dom";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getUserPaymentsStore from "../../../stores/user-store/payments-store";
import KhattabatUserPaymentsForm from "./user-payments-form/KhattabatUserPaymentsForm";
import UserPaymentsData from "./user-payments-data";

const UserPayments = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;
  const location = useLocation();

  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_PAYMENTS", "USER_PAYMENTS");
    getUserPaymentsStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("MONITOR_USER_PAYMENTS")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage("PAYMENT_DATA_HELPER");
        }}
      />
      <Stack
        spacing={3}
        sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}
      >
        <KhattabatUserPaymentsForm />
        <UserPaymentsData />
      </Stack>
    </ET3PageDiv>
  );
});
export default UserPayments;
